module.exports = __webpack_public_path__ + "img/clock.7aad521a.svg";